import { Injectable } from '@angular/core';
import { ContactI } from '@interfaces/contact.interface';
import { ComponentStore } from '@ngrx/component-store';
import { map, Observable } from 'rxjs';

export interface ContactState {
  timelineContact: ContactI;
}

@Injectable({
  providedIn: 'root',
})
export class TimelineStoreService extends ComponentStore<ContactState> {
  constructor() {
    super({ timelineContact: {} });
  }

  public timelineContact$: Observable<ContactI> = this.select((state) => state.timelineContact);

  public setContact(contact: ContactI): void {
    try {
      this.setState((state) => ({
        ...state,
        timelineContact: contact,
      }));
    } catch (error) {
      throw new Error(`ContactStoreService setCurrentContactId error: ${error}`);
    }
  }
}
